import { FC } from 'react'
import { CrmRolesEnum } from '@sparling/financial-common'
import { CompanyDetails } from '../CompanyDetails'
import { CompanyAccounts } from '../CompanyAccounts'
import { CompanyAuditLogs } from '../CompanyAuditLogs'
import { IntroducerPanel } from '../../UserProfile/IntroducerPanel'
import { UserKYC } from '../../UserProfile/UserKYC'
import { UserTransactions } from '../../UserProfile/UserTransactions'
import { UserTrades } from '../../UserProfile/UserTrades'
import { UserBalance } from '../../UserProfile/UserBalance'

export interface ITabList {
  tabLabel: string
  slug: string
  component: FC
  roles?: CrmRolesEnum[]
}

export const tabList: ITabList[] = [
  {
    tabLabel: 'Company Details',
    slug: 'details',
    component: CompanyDetails,
  },
  {
    tabLabel: 'KYC',
    slug: 'kyc',
    component: UserKYC,
  },
  {
    tabLabel: 'Audit Logs',
    slug: 'audit-logs',
    component: CompanyAuditLogs,
  },
  {
    tabLabel: 'Trades',
    slug: 'trades',
    component: UserTrades,
  },
  {
    tabLabel: 'Transactions',
    slug: 'transactions',
    component: UserTransactions,
  },
  {
    tabLabel: 'Balance',
    slug: 'balance',
    component: UserBalance,
  },
  {
    tabLabel: 'Client Accounts',
    slug: 'client-accounts',
    component: CompanyAccounts,
    roles: [CrmRolesEnum.AdminCrm],
  },
  {
    tabLabel: 'Introducer',
    slug: 'introducer',
    component: IntroducerPanel,
  },
]
